import { styled } from 'styled-components';

const Container = styled.div`
  display: flex;
  // flex-grow: 1;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  padding: 10pt;
  margin-bottom: 5pt;
  min-width: 0;
  max-width: 100%;
  height: auto;
  font-size: 1.5rem;

  color: black;

  background-color: rgba(192, 192, 192, 0.6);
`;

const Name = styled.div`
  font-size: 1.5rem;
  margin-right: 2pt;

  font-weight: bold;

  min-width: 0rem;
  max-width: 5.7rem;
  white-space: nowrap;
  overflow: hidden;
`;

const Rest = styled.div`
  display: flex;
  margin-left: 5pt;
  max-width: 100%;
  font-size: 1.5rem;
`;

type Props = {
  name: string;
  message: string;
};

export default function Row(props: Props) {
  return (
    <Container>
      <Name>{props.name}</Name>:<Rest>{props.message}</Rest>
    </Container>
  );
}
